import { render, staticRenderFns } from "./HelpCenter.vue?vue&type=template&id=1daecd10"
var script = {}
import style0 from "./HelpCenter.vue?vue&type=style&index=0&id=1daecd10&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports